import React from "react";
import { Grid, IconButton, TextField } from "@mui/material";
import { Send } from "@mui/icons-material";
import { SavedChatMenu } from "./ChatSavedMenu";

interface ChatInputProps {
    newMessageText: string;
    onMessageChange: (text: string) => void;
    onSendMessage: () => void;
    onAddChat: () => void;
    isDisabled: boolean;
    isLoading: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({
    newMessageText,
    onMessageChange,
    onSendMessage,
    onAddChat,
    isDisabled,
    isLoading,
}) => {
    return (
        <Grid container spacing={1} sx={{ marginTop: 0.5, alignItems: "center" }}>
            <Grid item>
                <SavedChatMenu handleAddChat={onAddChat} />
            </Grid>
            <Grid item sx={{ flexGrow: 1 }}>
                <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Type a message"
                    value={newMessageText}
                    disabled={isDisabled}
                    onChange={(e) => onMessageChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSendMessage();
                        }
                    }}
                />
            </Grid>
            <Grid item xs="auto">
                <IconButton color="primary" onClick={onSendMessage} disabled={isLoading || isDisabled}>
                    <Send />
                </IconButton>
            </Grid>
        </Grid>
    );
};
